import {Injectable} from '@angular/core';
import {ConfigService} from '@q9elements/ui-kit/common';
import {catchError, first, fromEvent, map, merge, mergeAll, of, throwError, timeout} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SimpleImagePreloadService {
  constructor() {}

  private static DefaultImage = `${ConfigService.environment.STATIC_FILES_URL}/icons/no-image.png`;

  public static defaultImage(image: string): typeof SimpleImagePreloadService {
    SimpleImagePreloadService.DefaultImage = image;

    return SimpleImagePreloadService;
  }

  public preloadImage(src: string, altSrc = this.constructor['DefaultImage']) {
    const vImg = new Image();

    const error = fromEvent(vImg, 'error').pipe(
      map(e => {
        throw new Error('Image error');
      })
    );
    const abort = fromEvent(vImg, 'abort').pipe(
      map(e => {
        throw new Error('Image loading abort');
      })
    );
    const loaded = fromEvent(vImg, 'load').pipe(
      map(e => src),
      timeout(6000),
      catchError(e => {
        return throwError(() => new Error('Image loading timeout'));
      })
    );

    vImg.src = src;

    return merge([error, abort, loaded]).pipe(
      mergeAll(),
      catchError(e => {
        console.warn(e);

        return of(SimpleImagePreloadService.DefaultImage);
      }),
      first()
    );
  }
}
